// i18n.js
import i18n from "i18next";
// import i18n from './i18n';
import { initReactI18next } from "react-i18next";

// Import your translation files
import enTranslations from "./locales/en/translations.json";
import esTranslations from "./locales/es/translations.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    es: { translation: esTranslations },
  },
  lng: localStorage.getItem("i18nextLng") || "en", // If you want to detect the user language, check out the i18next-browser-languagedetector plugin
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
